import React from 'react'
import Head from 'next/head'
import Genomics from '@src/routes/Configurators/products/Genomics'
import messages from '@src/routes/Configurators/messages'
import { useIntl } from 'react-intl'
import { useRouter } from '@src/routes'
import ConfiguratorPageError from '@src/routes/Configurators/utils/ConfiguratorPageError'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'

const Genomic = () => {
  const intl = useIntl()
  const router = useRouter()
  const product = router?.query?.product ?? ''
  const countryCode = router?.query?.country ?? ''
  let invalidProduct = false
  const productTitle = () => {
    const productKey = 'CONF_TITLE_' + product
    let title = intl.formatMessage({
      id: 'CONF_ERROR_PAGE',
      defaultMessage: 'Error Page',
    })
    try {
      title = intl.formatMessage(messages[productKey])
    } catch (error) {
      invalidProduct = true
    }
    return title
  }

  return (
    <React.Fragment>
      <Head>
        <title>{productTitle()}</title>
      </Head>
      {invalidProduct ? (
        <DefaultLayout spacing={LayoutSpacingOptions.MD}>
          <ConfiguratorPageError productCode={2} country={countryCode} />
        </DefaultLayout>
      ) : (
        <Genomics />
      )}
    </React.Fragment>
  )
}

export default Genomic
